// third party
import * as yup from 'yup';
import { format, isDate, isValid } from 'date-fns';

export const TIME_DEFINITION = ['byDateRange', 'byHours'];

const validationSchema = (intl) =>
    yup.object().shape({
        ticketType: yup
            .object()
            .shape({})
            .nullable()
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-tickettype-required' })),
        nonExistentClientCheck: yup.bool().nullable(),
        client: yup
            .object()
            .shape({})
            .nullable()
            .when('nonExistentClientCheck', {
                is: false,
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-client-required' }))
            }),
        clientLocation: yup.object().shape({}).nullable(),
        nonExistentClient: yup
            .string()
            .nullable()
            .when('nonExistentClientCheck', {
                is: true,
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-client-required' }))
            }),
        task: yup.object().shape({}).nullable(),
        timeDefinition: yup
            .string()
            .oneOf(TIME_DEFINITION, intl.formatMessage({ id: 'ui-comp-formvalidation-timedefinition-unexpectedvalue' }))
            .nullable(),
        startDate: yup
            .date()
            .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-startdate-invalid' }))
            .when('timeDefinition', {
                is: 'byDateRange',
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-startdate-required' }))
            }),
        endDate: yup
            .date()
            .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-enddate-invalid' }))
            .when('startDate', (startDate, schema) => {
                if (isDate(startDate) && isValid(startDate)) {
                    return schema.min(
                        startDate,
                        intl.formatMessage({
                            id: 'ui-comp-formvalidation-enddate-min',
                            values: { minValue: format(startDate, 'yyyy-MM-dd HH:mm:ss') }
                        })
                    );
                }
                return schema;
            })
            .when('timeDefinition', {
                is: 'byDateRange',
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-enddate-required' }))
            }),
        hours: yup
            .number()
            .nullable()
            .min(0)
            .max(1000)
            .when('timeDefinition', {
                is: 'byHours',
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-workduration-required' }))
            }),
        minutes: yup.number().nullable().min(0).max(1000),
        description: yup.string().required(intl.formatMessage({ id: 'ui-comp-formvalidation-description-required' })),
        signTicketCheck: yup.bool().nullable(),
        signatory: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-signatory-max', values: { maxValue: 255 } }))
            .nullable()
            .when('signTicketCheck', {
                is: true,
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-signatory-required' }))
            }),
        signature: yup
            .object()
            .shape({})
            .nullable()
            .when('signTicketCheck', {
                is: true,
                then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-signature-required' }))
            })
    });

export default validationSchema;
